import styled from 'styled-components';

export const NoCostEmiContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  margin: 8px 0px;
  p {
    font-size: clamp(14px, 2vw, 16px);
    opacity: 0.8;
    font-size: 16px;
    color: #6e6e6e;
  }
  div {
    font-size: clamp(12px, 2vw, 14px);
    display: flex;
    column-gap: 8px;
    color: #bec4c4;
    align-item: center;
  }
`;

export const NoCostEmiPaymentStyle = styled.div`
  padding: 3px 7px;
  background-color: rgb(207 241 226 / 53%);
  display: flex;
  span {
    font-size: clamp(10px, 2vw, 12px);
    color: #85d9ac;
  }
`;
